import { Chip, Tooltip } from "@mui/material";
import { CountText } from "./CountText";
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { MyListApi } from "../utils/restApi";
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../slices/notificationSlice";
import { useState } from "react";

export const LikeChip = ({ itemId, initialCount = 0, isLikedByUser = false }) => {

    const dispatch = useDispatch();
    const user = useSelector(state => state.login.user);

    const [count, setCount] = useState(initialCount);
    const [likedByUser, setLikedByUser] = useState(isLikedByUser);

    const like = () => {
        setCount(count + 1);
        setLikedByUser(true);
    }

    const unlike = () => {
        setCount(count - 1);
        setLikedByUser(false);
    }

    const reset = liked => {
        setCount(count);
        setLikedByUser(liked);
    }

    const handleClick = () => {
        if (likedByUser) {
            unlike();
            MyListApi.unlikeItem(itemId)
                .catch(error => {
                    reset(true);
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        } else {
            like();
            MyListApi.likeItem(itemId)
                .catch(error => {
                    reset(false);
                    dispatch(addNotification({
                        message: error.message,
                        type: 'error',
                    }));
                });
        }
    }

    return (
        <Tooltip title="Likes" placement="top" arrow>
            <Chip
                icon={likedByUser ? <FavoriteIcon fontSize="small" /> : <FavoriteBorderIcon fontSize="small" />}
                label={<CountText num={count || 0} />}
                size="small"
                variant={likedByUser ? 'filled' : 'outlined'}
                color={likedByUser ? 'primary' : 'default' }
                onClick={user ? handleClick : undefined}
                aria-label={`${count || 0} likes${user ? (likedByUser ? ', liked by you. Unlike' : '. Like') : ''}`}
                aria-pressed={user ? likedByUser : undefined}
            />
        </Tooltip>
    );
}